import { extend } from 'lodash-es';
import { WmsWorkspaceManagerService } from "@wms/workspace";
import {inject} from "@angular/core";

export interface WS {
  active: boolean;
  details: PageDetails;
  identifier: string;
  name: string;
  type: string;
}

export interface PageDetails {
  pageName?: string;
  tab?: string;
  icon?: string;
  isTemplate?: boolean;
}

const _activeWS: WS = {
  active: true,
  details: {pageName: 'Main', tab: 'DESIGN', icon: 'page'},
  identifier: "PAGE:Main",
  name: "Main",
  type: "PAGE"
};
let defaultWS: WS = _activeWS;

export class WsManager {
  private workspaceManager: WmsWorkspaceManagerService;

  constructor() {
    this.workspaceManager = inject(WmsWorkspaceManagerService);
  }

  loadDefaultWS(ws: WS = defaultWS) {
    // TODO: wait for the app variables to be load

    // $rs.$watch(':: Variables', function (nv) {
    //   if (nv) {
    //     openWS(ws.type, ws.name, ws.identifier, ws.details)
    //       .then(deferred.resolve, deferred.reject);
      // }
    // });

    // return this.ps.load(ws.details);
  }

  updateWSDetails(ws: WS, details?: PageDetails) {
    if (details) {
      extend(ws.details, details);
    }
    this.workspaceManager.setActiveWS(ws);
  }

  updateActiveWSDetails(details: PageDetails) {
    this.updateWSDetails(_activeWS, details);
  }


  // loadWS
  // updateWSDetails
  // load(Details)
}
